import {
  Component,
  ElementRef,
  inject,
  InputSignal,
  input,
  Signal,
  viewChild,
} from '@angular/core';
import { ContentType } from '../../pages/content-creation/content-creation';
import { SelectComponent } from '@kinomap-dev/ng-ui-lib/forms';
import { FormGroup, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LowerCasePipe, NgClass, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CreateContentService } from '../../services/create-content.service';
import { QuillEditorComponent } from 'ngx-quill';
// import { TagsElement } from '../tags-element/tags-element';
import { InputElement } from '../input-element/input-element';
import { CountryService } from '../../services/country.service';
import { VehiculeService } from '../../services/vehicule.service';
import { AdditionalData } from '../additional-data/additional-data';
import { MediaBlockService } from '../../services/media-block-service';
import { SPORT_TYPES } from '../../types/sport.type';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ApiService } from '../../services/api.service';
import { HttpResourceRef } from '@angular/common/http';
import { ProfileService } from '../../services/profile.service';
import { SelectField } from '../select-field/select-field';

@Component({
  selector: 'app-information-block',
  imports: [
    SelectComponent,
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    TranslateModule,
    QuillEditorComponent,
    // TagsElement,
    NgStyle,
    InputElement,
    AdditionalData,
    UpperFirstLetterPipe,
    SelectField,
    LowerCasePipe,
  ],
  templateUrl: './information-block.html',
  styleUrl: './information-block.scss',
})
export class InformationBlock {
  public mediaBlockService: MediaBlockService = inject(MediaBlockService);
  public apiService: ApiService = inject(ApiService);
  protected readonly sportTypes = SPORT_TYPES;
  readonly contentType: InputSignal<ContentType | undefined> = input<ContentType | undefined>();
  readonly informationForm: InputSignal<FormGroup> = input.required<FormGroup>();
  protected themesRessources: HttpResourceRef<string[] | undefined> =
    this.apiService.getTrainingThemeRessources;
  protected readonly profileService: ProfileService = inject(ProfileService);

  titleFocused: boolean = false;
  recordedWithFocused: boolean = false;
  descriptionFocused: boolean = false;
  private createContentService: CreateContentService = inject(CreateContentService);
  public countryService: CountryService = inject(CountryService);
  public vehiculeService: VehiculeService = inject(VehiculeService);

  editorModules = {
    toolbar: [['bold', 'italic', 'underline'], ['link']],
  };

  get titleControl(): FormControl {
    return this.informationForm().get('title') as FormControl;
  }

  get recordedWithControl(): FormControl {
    return this.informationForm().get('recordedWith') as FormControl;
  }

  changeLanguage(languageId: string): void {
    const control: FormControl = this.informationForm().get('languageId') as FormControl;
    if (control) control.setValue(parseInt(languageId));
  }

  changeVehicule(vehiculeId: string) {
    const control: FormControl = this.informationForm().get('vehiculeId') as FormControl;
    if (control) control.setValue(parseInt(vehiculeId));
  }

  private readonly themeSelect: Signal<ElementRef<HTMLElement> | undefined> = viewChild(
    'themeSelect',
    { read: ElementRef },
  );

  changeTheme(theme: string): void {
    const control: FormControl = this.informationForm().get('theme') as FormControl;
    if (control) control.setValue(theme || undefined);
    if (theme) return;
    const select: HTMLSelectElement | null | undefined =
      this.themeSelect()?.nativeElement.querySelector('select');
    if (select) select.selectedIndex = 0;
  }

  changeSport(sport: string) {
    const control: FormControl = this.informationForm().get('sport') as FormControl;
    if (control) control.setValue(sport);
  }

  tagsChanges(tagsIds: number[]) {
    const control: FormControl = this.informationForm().get('tagsIds') as FormControl;
    if (control) control.setValue(tagsIds);
  }

  onTitleChange(value: string): void {
    this.createContentService.title.set(value);
  }

  get titleLabel(): string {
    switch (this.contentType()) {
      case 'scenic':
        return 'content_creation.input.title_scenic.label';
      case 'gps-only':
        return 'content_creation.input.title_gps.label';
      default:
        return 'content_creation.input.title.label';
    }
  }

  get recordedWithLabel(): string {
    switch (this.contentType()) {
      case 'scenic':
        return 'content_creation.input.recorded_with_scenic.label';
      case 'gps-only':
        return 'content_creation.input.recorded_with_gps.label';
      default:
        return 'content_creation.input.recorded_with.label';
    }
  }

  get recordedWithTooltip(): string {
    switch (this.contentType()) {
      default:
        return 'content_creation.input.recorded_with.tooltip';
    }
  }
}
